module.exports = __webpack_public_path__ + "img/menu1.55f4e9ed.png";